import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { Diagnostic } from '@ionic-native/diagnostic';
import { Network } from '@ionic-native/network'
import { Camera } from '@ionic-native/camera';
import { IonicStorageModule } from '@ionic/storage';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ApiProvider } from '../providers/api/api';
import { DataProvider } from '../providers/data/data';
import { HttpClientModule } from '@angular/common/http';
import { PipesModule } from '../pipes/pipes.module'
import { ControlEquiposDetallePageModule } from '../pages/control-equipos-detalle/control-equipos-detalle.module';
import { ComponentsModule } from '../components/components.module';

import { ControlEquiposPageModule } from '../pages/control-equipos/control-equipos.module';
import { LoginPageModule } from '../pages/login/login.module';
import { RegresoViajePageModule } from '../pages/regreso-viaje/regreso-viaje.module';


@NgModule({
  declarations: [
    MyApp,
    HomePage,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot({
      name: 'tmsDB',
      driverOrder: ['sqlite', 'websql','indexeddb']
    }),
    PipesModule,
    ControlEquiposDetallePageModule,
    ComponentsModule,
    ControlEquiposPageModule,
    LoginPageModule,
    RegresoViajePageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage
  ],  
  providers: [
    StatusBar,
    SplashScreen,
    Camera,
    Diagnostic,
    Network,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ApiProvider,
    DataProvider
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts